import { Link, NavLink } from '@remix-run/react'
import { Button } from '#app/components/ui/button.tsx'
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle,
	SheetDescription,
	SheetTrigger,
} from '#app/components/ui/sheet.tsx'
import { Icon, href as iconsHref } from '#app/components/ui/icon.tsx'
import LogoImage from '#app/images/og-hydrofarm-logo.png'
import { useState } from 'react'

const links = [
	{ href: '/', label: 'Home' },
	{ href: '/about', label: 'About' },
	{ href: '/products', label: 'Products' },
	{ href: '/dispensaries', label: 'Dispensaries' },
	{ href: '/contact', label: 'Contact' },
]

export default function Header() {
	//console.log(data)

	return (
		<header className="relative bg-theme-dark py-6 text-white">
			<div className="container relative">
				<div className="relative flex justify-between">
					<div className="relative flex gap-6">
						<Logo />
					</div>
					<DesktopNav />
					<MobileNav />
				</div>
			</div>
		</header>
	)
}

function Logo() {
	return (
		<div className="flex items-center gap-2 text-xl font-bold">
			<Link to="/" className="">
				O.G. Hydrofarms
			</Link>
		</div>
	)
}

function DesktopNav() {
	return (
		<nav className="relative hidden lg:flex">
			{links.map(({ href, label }) => (
				<div key={href} className="relative flex">
					<NavLink
						to={href}
						className={({ isActive }) =>
							isActive
								? 'flex items-center px-4 py-3 text-base font-medium text-theme-blue'
								: 'flex items-center px-4 py-3 text-base font-medium bg-blend-multiply hover:text-theme-blue'
						}
					>
						{label}
					</NavLink>
				</div>
			))}
		</nav>
	)
}

function MobileNav() {
	const [open, setOpen] = useState(false)

	const handleLinkClick = () => {
		setOpen(false)
	}

	return (
		<div className="lg:hidden">
			<Sheet open={open} onOpenChange={setOpen}>
				<SheetTrigger asChild>
					<Button>
						<Icon name="hamburger-menu" />
						Menu
					</Button>
				</SheetTrigger>
				<SheetContent side="left" className="w-80">
					<SheetHeader className="pb-6">
						<SheetTitle>
							<img
								src={LogoImage}
								alt="O.G. Hydrofarms"
								className="mx-auto h-28 w-auto"
							/>
						</SheetTitle>
						<SheetDescription></SheetDescription>
					</SheetHeader>

					<nav>
						{links.map(({ href, label }) => (
							<div key={href} className="relative flex">
								<NavLink
									to={href}
									onClick={handleLinkClick}
									className={({ isActive }) =>
										isActive
											? 'min-w-full rounded-md bg-primary/10 px-4 py-2 text-sm font-medium text-primary'
											: 'hover:bg-primary-10 min-w-full rounded-md px-4 py-2 text-sm font-light text-primary'
									}
								>
									{label}
								</NavLink>
							</div>
						))}
					</nav>
				</SheetContent>
			</Sheet>
		</div>
	)
}
